import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Select from 'react-select';

import { focusAfterTimeout, isArrayEqual } from '../../util';

import { createOrUpdateTeam, stopEditingTeam, deleteTeam } from '../../actions/teams';

import Switch from 'react-switch';

const DEFAULT_TEAM = {
  name: '',
  leaders: [],
  members: [],
}

class UpdateTeamModal extends Component{

  state = {
    editingTeam: DEFAULT_TEAM,
    error: null,
    message: null,
    confirmingDelete: false,
  }

  employeesMappedById(){
    const employees = this.props.employees;

    return _.keyBy(employees, '_id');
  }

  userData(userId){
    return this.employeesMappedById()[userId];
  }

  componentWillReceiveProps(nextProps){
    //console.log('component received nextprops: ', nextProps);

    //const editingUser = { ...nextProps.editingUser.user };

    const errorForState = nextProps.editingTeam.error || null;
    const messageForState = nextProps.editingTeam.message || null;
    const teamDataForState = nextProps.editingTeam.team || DEFAULT_TEAM;

    this.setState({
      editingTeam: teamDataForState,
      error: errorForState,
      message: messageForState,
      confirmingDelete: false,
    });

    //focus first input
    if(nextProps.editingTeam && nextProps.editingTeam.editing){
      focusAfterTimeout(this, 'teamNameInput');
    }
  }

  updateTeamField(fieldName, fieldValue){
    this.clearErrorAndMessage();

    let updateTeam = {
      ...this.state.editingTeam
    }
    updateTeam[fieldName] = fieldValue;

    this.setState({
      editingTeam: updateTeam
    });
  }

  clearErrorAndMessage(){
    this.setState({
      error: null,
      message: null,
    });
  }

  createOrUpdateTeam(){
    this.props.createOrUpdateTeam(this.state.editingTeam);
  }

  deleteTeam(){
    this.props.deleteTeam(this.state.editingTeam, this.props.onDelete);
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else if(this.state.message){
      return <div className="form-message success">{this.state.message}</div>;
    }
    else{
      return <div className="form-message placeholder">&nbsp;</div>;
    }
  }

  formIsDirty(){

    const { syncingWithServer, teamIsNew, team } = this.props.editingTeam;

    if( teamIsNew ||
      team.name !== this.state.editingTeam.name ||
      !isArrayEqual(team.leaders, this.state.editingTeam.leaders) ||
      !isArrayEqual(team.members, this.state.editingTeam.members)
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getSaveButtonText(){
    const { syncingWithServer, teamIsNew } = this.props.editingTeam;

    if(teamIsNew){
      if(syncingWithServer){
        return "Creating team...";
      }
      else{
        return "Create new team";
      }
    }
    else{
      if(syncingWithServer){
        return "Saving...";
      }
      else{
        return "Save";
      }
    }

  }

  removeUserFromTeam(userId, userType){
    if(userType === 'leader'){
      this.setState({
        editingTeam: {
          ...this.state.editingTeam,
          leaders: _.without(this.state.editingTeam.leaders, userId)
        }
      });
    }
    else if(userType === 'member'){
      this.setState({
        editingTeam: {
          ...this.state.editingTeam,
          members: _.without(this.state.editingTeam.members, userId)
        }
      });
    }
  }

  addUserToTeam(userId, userType){
    if(userType === 'leader'){
      this.setState({
        editingTeam: {
          ...this.state.editingTeam,
          //leaders: _.union(this.state.editingTeam.leaders, [userId])
          leaders: [...this.state.editingTeam.leaders, userId]
        }
      });
    }
    else{
      this.setState({
        editingTeam: {
          ...this.state.editingTeam,
          members: [...this.state.editingTeam.members, userId]
        }
      });
    }
  }

  renderLeaderOrMember(userId, leaderOrMember){
    const userData = this.userData(userId);

    return(
      <li className="removable" key={userId}>
        <div className="name">{`${userData.firstName} ${userData.lastName}`}</div>
        <div className="action" onClick={() => { this.removeUserFromTeam(userId, leaderOrMember); }}>X</div>
      </li>
    )
  }

  getUserOptionsForSelect(usersType){

    const teamLeaders = this.state.editingTeam.leaders;
    const teamMembers = this.state.editingTeam.members;

    const allLeadersAndMembersIds = _.join(_.union(teamLeaders, teamMembers), ' ');

    const employeesNotAlreadyLeadersOrMembers = _.filter(this.props.employees, employee => {
      return allLeadersAndMembersIds.indexOf(employee._id) === -1;
    });

    const employeesNotAlreadyLeadersOrMembersOfCorrectRole = _.filter(employeesNotAlreadyLeadersOrMembers, employee => {
      if(usersType === 'member'){
        return employee.role === 'manager' || employee.role === 'employee' || employee.role === 'salesleader';
      }
      else{
        return employee.role === 'salesleader' || employee.role === 'manager';
      }
    });

    const employeeOptions = _.map(employeesNotAlreadyLeadersOrMembersOfCorrectRole, employee => {
      return {
        value: employee._id,
        label: employee.firstName + ' ' + employee.lastName
      }
    });

    return employeeOptions;
  }

  renderUsers(users, usersType){
    return (
      <ul>
        {_.map(users, user => this.renderLeaderOrMember(user, usersType))}
        <li className="add-new">
          <Select
            placeholder={`Add ${usersType}...`}
            classNamePrefix={'react-select'}
            className='react-select-container user-select'
            value={''}
            options={this.getUserOptionsForSelect(usersType)}
            onChange={(option) => { this.addUserToTeam(option.value, usersType); }}
            isSearchable={true}
          />
        </li>
      </ul>
    )
  }

  render(){

    if(!this.props.editingTeam.editing){
      return null;
    }

    const { confirmingDelete } = this.state;

    const { _id, name, leaders, members } = this.state.editingTeam;

    const isNewTeam = _id ? false : true;

    const { syncingWithServer } = this.props.editingTeam;

    return (
      <div className="modal update-team">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.stopEditingTeam}>X</div>
          <div className="modal-content">
            <form className="velocity-form">
              <h2>{isNewTeam ? 'Add' : 'Update'} team</h2>
              {this.renderFormMessage()}
              <div className="form-group">
                <div className="input-group full-width">
                  <label htmlFor="velocity-team-name">Team name</label>
                  <input
                    ref={input => { this.teamNameInput = input; }}
                    id="velocity-team-name"
                    autoComplete="off"
                    type="text"
                    value={name}
                    onChange={e => {this.updateTeamField('name', e.target.value)}}
                    />
                </div>
              </div>
              <div className="form-section half-section">
                <div className="form-section-label left">Leader(s)</div>
                  <div className={'form-group removable-items'}>
                    {this.renderUsers(leaders, 'leader')}
                  </div>
              </div>
              <div className="form-section half-section">
                <div className="form-section-label left">Members</div>
                  <div className={'form-group removable-items'}>
                    {this.renderUsers(members, 'member')}
                  </div>
              </div>
            </form>
          </div>
          <div className="modal-actions">
            {!this.formIsDirty() && !syncingWithServer && confirmingDelete &&
              <button className="button danger-button" onClick={this.deleteTeam.bind(this)}>Delete team forever</button>
            }
            {!this.formIsDirty() && !syncingWithServer && confirmingDelete &&
              <button className="button grey-button" onClick={() => { this.setState({ confirmingDelete: false })  } }>Nevermind</button>
            }
            {!this.formIsDirty() && !syncingWithServer && !confirmingDelete &&
              <button className="button primary" onClick={this.props.stopEditingTeam}>Done</button>
            }
            {(this.formIsDirty() || syncingWithServer) &&
              <template>
                <button className="button primary" onClick={this.createOrUpdateTeam.bind(this)} disabled={syncingWithServer}>{this.getSaveButtonText()}</button>
                <button className="button grey-button" onClick={this.props.stopEditingTeam}>Cancel</button>
              </template>
            }
            {!this.formIsDirty() && !syncingWithServer && !confirmingDelete &&
              <button className="button transparent-button sm secondary" onClick={() => { this.setState({ confirmingDelete: true }) }}>Delete team</button>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    employees: state.employees.data,
    editingTeam: state.editingTeam,
  }
}

export default connect(mapStateToProps, { createOrUpdateTeam, stopEditingTeam, deleteTeam })(UpdateTeamModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateTeam.js